export function eurToCents(amountStr: string): number {
  const trimmed = amountStr.trim().replace(',', '.');
  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) {
    throw new Error('Invalid EUR amount');
  }
  const [whole, frac = ''] = trimmed.split('.');
  const cents = Number(whole) * 100 + Number((frac + '00').slice(0, 2));
  if (!Number.isFinite(cents) || cents < 0 || cents > 99_999_999_99) {
    throw new Error('Amount out of range');
  }
  return cents;
}

export function centsToEurString(cents: number): string {
  if (!Number.isInteger(cents) || cents < 0) throw new Error('Invalid cents');
  const whole = Math.floor(cents / 100);
  const frac = cents % 100;
  return `${whole}.${frac.toString().padStart(2, '0')}`;
}

export function formatEur(cents: number): string {
  return `€${centsToEurString(cents)}`;
}
